export default {
  title: 'Modo ocupado',
  form: {
    has_busy_mode: {
      label: 'Modo ocupado',
    },
    busy_mode_minutes: {
      label: '¿Cuánto tiempo añadir a tu tiempo de preparación habitual?',
      options: {
        10: '10 min',
        15: '15 min',
        20: '20 min',
        25: '25 min',
        30: '30 min',
        45: '45 min',
        60: '1 hora',
      },
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados correctamente',
  },
};
